import { SelectedJobState } from '../../reducers/jobs.reducer';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import * as jobActions from '../../actions/jobs.actions';
import {
  LoadJobAssignments,
  RequestToLoadJobAssignments,
} from '../../actions/jobs.actions';
import { Store } from '@ngrx/store';
import * as fromJobs from '../../reducers';
import { Assignment } from '../../models/assignment.model';
import { selectCurrentUser } from '../../../core/selectors/auth';
import { Observable } from 'rxjs';
import { User } from '../../../lib/classes/user';

@Component({
  selector: 'mj-selected-job-info',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './selected-job-info.component.html',
  styleUrls: ['selected-job-info.component.scss'],
})
export class SelectedJobInfoComponent implements OnInit, OnDestroy, OnChanges {
  @Input() jobState: SelectedJobState;
  @Input() categories: any[];
  @Input() jobTitleSuggestions: any[];
  @Input() jobAssignments: Assignment[];
  @Output() saveJobState = new EventEmitter<any>();
  @Output() updateJobState = new EventEmitter<any>();

  // intervalId: NodeJS.Timeout;
  form: FormGroup;
  formSub$: any;
  public isJobSaved: boolean = true;
  private currentUser$: Observable<{ currentUser: User }>;

  constructor(
    private fb: FormBuilder,
    private store: Store<fromJobs.State>,
    private _translate: TranslateService
  ) {
    this.form = this._createForm();
  }

  private _createForm() {
    return this.fb.group({
      category: null,
      title: '',
      employment_type: '',
      positions: 1,
      internal_title: '',
    });
  }

  private getPositions() {
    const { value } = this.form.get('positions');
    if (value < 1) {
      return 1;
    } else {
      return value;
    }
  }

  ngOnInit() {
    // this.intervalId = setInterval(() => {
    //     if (this.jobState.job && !this.jobState.job.is_published) {
    //         this.saveJobState.emit(this.jobState);
    //     }
    // }, Number(environment.autosaveIntervalInMs));
    this._onChanges();
    this.currentUser$ = this.store.select(selectCurrentUser);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.jobState && this.jobState.job) {
      this.form.markAsPristine();
      this.form.patchValue({
        category: this.jobState.job.category || null,
        employment_type: this.jobState.job.employment_type || '',
        positions: this.getPositions(),
      });
      if (this.form.value.title !== this.jobState.job.title) {
        this.form.patchValue({
          title: this.jobState.job.title || '',
        });
      }
      if (this.form.value.internal_title !== this.jobState.job.internal_title) {
        this.form.patchValue({
          internal_title: this.jobState.job.internal_title || '',
        });
      }
      this.form.markAsPristine();
      this.isJobSaved = this.jobState.isSaved;
    }
  }

  ngOnDestroy() {
    // clearInterval(this.intervalId);
    if (this.formSub$) {
      this.formSub$.unsubscribe();
    }
  }

  _onChanges() {
    this.formSub$ = this.form.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        map(formValue => {
          if (this.form.dirty) {
            this.updateJobState.emit({
              ...this.jobState,
              job: {
                ...this.jobState.job,
                ...formValue,
              },
            });
            this.form.markAsPristine();
          }
        })
      )
      .subscribe();
  }

  public onJobChange($event: any) {
    if (JSON.stringify(this.jobState.job) === JSON.stringify($event)) {
      return;
    }
    this.updateJobState.emit({
      ...this.jobState,
      job: {
        ...this.jobState.job,
        ...$event,
      },
    });
  }

  public compareFn(c1: any, c2: any): boolean {
    return c1 && c1.id && c2 ? c1.id === c2 : c1 === c2;
  }

  fetchJobTitleSuggestions(term: String) {
    this.store.dispatch(
      new jobActions.LoadJobTitleSuggestions({
        term: term,
      })
    );
  }

  updateJobTitle(term: String) {
    this.form.patchValue({
      title: term,
      internal_title: term,
    });
    this.form.markAsDirty();
  }

  onUnitChanged($event: boolean) {
    if (!$event) {
      return;
    }
    this.store.dispatch(
      new RequestToLoadJobAssignments({
        jobId: this.jobState.job.id,
      })
    );
  }
}
